module.exports = __webpack_public_path__ + "static/media/haacp.85974d07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/haacp.png
// module id = 1584
// module chunks = 0